<script lang="ts">

    import { onMount } from "svelte";
    import { ToastProperties, storeNotification, storeNotificationClicked } from "../js/toaster";
    import { square, deglingos, minitel } from '../store/store';
    import { storeCurRoute, idPageProjets } from './router/router';

    export let props: ToastProperties = {message: "", level: ""};
    let show_toaster: boolean = false;
	let message: string = "";

    onMount(async () => {
        launch_toast();
        const unsubscribe = storeNotification.subscribe((storeNotification) => {
            message = storeNotification.message;
        });

    });

    function launch_toast() {
        setTimeout(function() { 
            show_toaster = true;
            setTimeout(function(){ show_toaster = false; }, 6200);
        }, 10000);
    }

    function updateStoreNotificationClicked() {
        storeCurRoute.set(idPageProjets);
    }

</script>

<style lang="scss">

    $toast_size: 350px;

    .toast {
        display: none;
        max-width: 0px;
        height: 50px;
        margin: auto;
        background-color: $color_secondary;
        color: #fff;
        text-align: center;
        border-radius: 2px;
        z-index: 1;
        font-size: 1em;
        white-space: nowrap;
        border-radius: 10px;
        cursor: pointer;
        &__square {
            background-color: $color_secondary;
            color: $color_primary;
        }
        &__deglingos {
            background-color: $color_primary;
            border: 1px solid $color_secondary;
            color: $color_secondary;
        }
        &__minitel {
            background-color: $color_minitel_green;
            color: $color_black;
            font-family: "minitel";
            font-size: 0.5em;
        }
        &__displayed {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            animation: up 0.2s, fadein 1s 0.2s, expand 1s 0.2s, stay 4s 1.2s, fadeout 1s 5.2s;
            overflow: hidden;
            margin: 4px 4px 4px 4px;
        }
    }

    @keyframes fadein {
        from {opacity: 0;}
        to {opacity: 1;}
    }

    @keyframes up {
        from {height: 0px}
        to {height: 50px}
    }

    @keyframes expand {
        from {min-width: 0px}
        to {min-width: $toast_size}
    }

    @keyframes stay {
        from {min-width: $toast_size}
        to {min-width: $toast_size}
    }

    @keyframes shrink {
        from {min-width: $toast_size} 
        to {min-width: 0px}
    }

    @keyframes fadeout {
        from {min-width: $toast_size; opacity: 1;}
        to {min-width: $toast_size; opacity: 0;}
    }

    @include large {
        $toast_size: 550px;

        .toast {
            &__minitel {
                font-size: 0.8em;
            }
        }

        @keyframes expand {
            from {min-width: 0px}
            to {min-width: $toast_size}
        }

        @keyframes stay {
            from {min-width: $toast_size}
            to {min-width: $toast_size}
        }

        @keyframes shrink {
            from {min-width: $toast_size} 
            to {min-width: 0px}
        }

        @keyframes fadeout {
            from {min-width: $toast_size; opacity: 1;}
            to {min-width: $toast_size; opacity: 0;}
        }
    }

</style>

{#if (!$storeNotificationClicked)}
<div class="toast"
    class:toast__displayed={show_toaster}
    class:toast__square={$square}
    class:toast__deglingos={$deglingos}
    class:toast__minitel={$minitel}
    on:click={() => updateStoreNotificationClicked()}>
    <div>{message}</div>
</div>
{/if}
